import { FC } from 'react';
import styled from 'styled-components';
import { LockIcon } from 'src/common/images/LockIcon';
import { MasterCardIcon } from 'src/common/images/MasterCardIcon';
import { Flex } from '@summer/react-kit';
import { rgba } from 'polished';
import { IntlFormattedMessage } from 'src/common/components/IntlFormattedMessage';

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const CreditCardInfo = styled.p`
  color: ${({ theme }) => theme.text.secondary};
  font-size: 0.75rem;
  max-width: 15.625rem;
`;

const StyledLockIcon = styled(LockIcon)`
  margin-right: 1rem;
`;

const Separator = styled.div`
  width: 100%;
  height: 0.125rem;
  background: ${({ theme }) => rgba(theme.colors.grey2, 0.5)};
  margin-bottom: 1rem;
`;

const StyledMasterCardIcon = styled(MasterCardIcon)`
  width: 3rem;
`;

const Subtitle = styled.p`
  color: ${({ theme }) => theme.text.secondary};
  font-size: 0.75rem;
  margin-bottom: 1rem;
`;

const MainPageConsentsHeader: FC = () => {
  return (
    <>
      <Header>
        <Flex alignCenter>
          <StyledLockIcon />
          <CreditCardInfo>
            <IntlFormattedMessage id="main.safety" />
          </CreditCardInfo>
        </Flex>
        <StyledMasterCardIcon />
      </Header>
      <Separator />
      <Subtitle>
        <IntlFormattedMessage id="main.dataHeading" />
      </Subtitle>
    </>
  );
};

export default MainPageConsentsHeader;
